module.exports = __webpack_public_path__ + "media/uber-logo.d054b881a33ad01f3f6027a2a5367717.svg";